module.exports = __webpack_public_path__ + "img/partner-2.8a30a254.png";